import { isJsChunkLoadError } from "./isJsChunkLoadError";

export const JS_CHUNK_RELOAD_KEY = "adm:js-chunk-load-reloaded";

export function reloadOnceOnJsChunkError(err, storage, reload) {
  if (!isJsChunkLoadError(err)) return;
  try {
    const store = storage || window.sessionStorage;
    if (store.getItem(JS_CHUNK_RELOAD_KEY)) return;
    store.setItem(JS_CHUNK_RELOAD_KEY, "1");
  } catch (_) {
    // Safari privado/storage bloqueado: sem guarda persistente o reload entra em loop
    return;
  }
  const doReload = reload || (() => window.location.reload());
  doReload();
}
